import { render, staticRenderFns } from "./hookTable.vue?vue&type=template&id=61587656&scoped=true&"
import script from "./hookTable.vue?vue&type=script&lang=ts&"
export * from "./hookTable.vue?vue&type=script&lang=ts&"
import style0 from "./hookTable.vue?vue&type=style&index=0&id=61587656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61587656",
  null
  
)

export default component.exports